
/**
 * @roxi/routify 2.18.12
 * File generated Mon Mar 24 2025 14:16:30 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.18.12"
export const __timestamp = "2025-03-24T14:16:30.695Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports
import __fallback from '../src/pages/_fallback.svelte'
import __join from '../src/pages/[join].svelte'
import _attendees_index from '../src/pages/attendees/index.svelte'
import _cards__id from '../src/pages/cards/[id].svelte'
import _cards_index from '../src/pages/cards/index.svelte'
import _cards_new from '../src/pages/cards/new.svelte'
import _index from '../src/pages/index.svelte'
import _new_sign_up from '../src/pages/new_sign_up.svelte'
import _review_index from '../src/pages/review/index.svelte'
import _sign_in_index from '../src/pages/sign_in/index.svelte'
import _signup_cancelled from '../src/pages/signup/cancelled.svelte'
import _signup_index from '../src/pages/signup/index.svelte'
import _signup_success from '../src/pages/signup/success.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isFallback": true,
      "path": "/_fallback",
      "component": () => __fallback
    },
    {
      "isPage": true,
      "path": "/:join",
      "id": "__join",
      "component": () => __join
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/attendees/index",
          "id": "_attendees_index",
          "component": () => _attendees_index
        }
      ],
      "path": "/attendees"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/cards/:id",
          "id": "_cards__id",
          "component": () => _cards__id
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/cards/index",
          "id": "_cards_index",
          "component": () => _cards_index
        },
        {
          "isPage": true,
          "path": "/cards/new",
          "id": "_cards_new",
          "component": () => _cards_new
        }
      ],
      "path": "/cards"
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => _index
    },
    {
      "isPage": true,
      "path": "/new_sign_up",
      "id": "_new_sign_up",
      "component": () => _new_sign_up
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/review/index",
          "id": "_review_index",
          "component": () => _review_index
        }
      ],
      "path": "/review"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/sign_in/index",
          "id": "_sign_in_index",
          "component": () => _sign_in_index
        }
      ],
      "path": "/sign_in"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/signup/cancelled",
          "id": "_signup_cancelled",
          "component": () => _signup_cancelled
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/signup/index",
          "id": "_signup_index",
          "component": () => _signup_index
        },
        {
          "isPage": true,
          "path": "/signup/success",
          "id": "_signup_success",
          "component": () => _signup_success
        }
      ],
      "path": "/signup"
    }
  ],
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

